import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  className?: string;
}

export const Input = ({ 
  label, 
  hint, 
  error, 
  className = '', 
  ...props 
}: InputProps) => (
  <label className="block space-y-1.5">
    {label && (
      <span className="text-sm font-medium text-slate-700 dark:text-slate-200">
        {label}
      </span>
    )}
    <input 
      className={`
        min-h-[48px] w-full rounded-xl border bg-white/95 px-3.5 py-2.5 text-slate-900 placeholder:text-slate-400
        dark:bg-slate-900/90 dark:text-slate-100
        focus:border-brand focus:ring-2 focus:ring-brand/30 focus:outline-none
        transition-colors duration-200
        ${error ? 'border-red-500' : 'border-slate-300 dark:border-slate-700'} 
        ${className}
      `} 
      {...props}
    />
    {hint && !error && (
      <span className="text-xs text-slate-500 dark:text-slate-400">
        {hint}
      </span>
    )}
    {error && (
      <span className="text-xs text-red-600 dark:text-red-400">
        {error}
      </span>
    )}
  </label>
);
